import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { OdataResponse } from '@app/shared/interfaces/odata-response';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { AttributesGroup } from '@app/shared/interfaces/Attribute';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { ChangeGroupSort } from '@product/shared/models/AttributeDTO';
import { tap } from 'rxjs';

@Component({
  selector: 'app-attribute-set',
  templateUrl: './attribute-set.component.html',
  styleUrls: ['./attribute-set.component.less'],
})
export class AttributeSetComponent extends BaseComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  editId = 0;
  nodes: NzTreeNodeOptions[];
  searchValue = '';
  groupsLoading = false;
  attributes = new Set<number>();
  showGroupInput = false;
  tempAttributeGroup: AttributesGroup = {
    Name: '',
  };
  constructor(private messageService: NzMessageService, injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  override submit() {
    this.submitChanges.emit();
  }
  afterSubmit() {
    //this.commonService.dropDownMetaData['attributeSetId'] = [];
    this.commonService.dropDownMetaData['AttributeSet'] = [];
  }
  recordLoaded(record: any) {
    if (this.mode !== 'edit') return;
    this.nodes = [];
    this.connectionService.get(
      `${AppConfigService.settings.baseUrl}data-api/AttributeGroup?expand=Attributes&filter=AttributeSetId eq ${record.Id}`,
      (d: OdataResponse) => {
        let attributeGroups = d.value as any[];
        attributeGroups = attributeGroups.sort((a, b) => {
          return a.Position - b.Position;
        });

        attributeGroups.forEach((group) => {
          let node: NzTreeNodeOptions = {
            title: group.Name,
            key: group.Id.toString(),
            icon: undefined,
          };

          this.nodes = [...this.nodes, node];
        });

        let tempNodes = JSON.stringify(this.nodes);
        this.nodes = [];
        this.nodes = JSON.parse(tempNodes);
      }
    );
  }

  selectionChanged() {
    this.formGroup.controls['Attributes'].markAsDirty();
    this.formGroup.controls['Attributes'].markAsTouched();
  }

  beforeSubmit() {
    const set = this.formGroup.value;
    if (set.AttributeGroups == null) {
      set.AttributeGroups = [];
    }
    return set;
  }

  cleanRecord(record: any) : any{
    return record;
  }

  addNewGroup() {
    this.tempAttributeGroup.Name = '';
    this.showGroupInput = true;
  }
  submitNewGroup() {
    if (
      this.tempAttributeGroup.Name == null ||
      this.tempAttributeGroup.Name == ''
    ) {
      this.messageService.error('Please write the name of the group.');
      return;
    }
    this.connectionService.create(
      `${AppConfigService.settings.dataApiUrl}AttributeGroup`,
      this.tempAttributeGroup,
      (response) => {
        const groups = this.AttributeGroups;
        groups.push(response);
        this.formGroup.get('AttributeGroups')?.setValue(groups);
        this.tempAttributeGroup.Name = '';
        this.formGroup.markAsTouched();
        this.formGroup.markAsDirty();
      }
    );
  }
  get AttributeGroups() {
    let groups = this.formGroup.get('AttributeGroups')
      ?.value as AttributesGroup[];
    groups = groups.sort((a, b) => a.Position - b.Position);
    return groups;
  }
  dropGroup(event: any) {
    if (this.mode !== 'edit') return;
    this.groupsLoading = true;
    const newIndex = event.currentIndex;
    const oldIndex = event.previousIndex;
    const draggedGroup = this.AttributeGroups[oldIndex];
    const offsetGroup = this.AttributeGroups[newIndex];
    const params: ChangeGroupSort = {
      attributeSetId: this.formGroup.get('Id')?.value ?? 0,
      draggedGroupId: draggedGroup.Id!,
      offsetGroupId: offsetGroup.Id!,
    };
    this.attributesService.changeGroupOrder(params).subscribe((groups) => {
      const attributeGroups = groups as any[];
      this.formGroup.get('AttributeGroups')?.setValue(
        attributeGroups.map((x) => {
          return {
            Id: x.id,
            AttributeSetId: x.attributeSetId,
            Name: x.name,
            Position: x.position,
            RelatedObjectType: x.relatedObjectType,
          };
        })
      );
      this.groupsLoading = false;
    });
  }
  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['Description'] = [null, []];
    controlsToReturn['IsDefault'] = [false, []];
    controlsToReturn['AttributeGroups'] = [null, []];

    return controlsToReturn;
  }
  startEditGroup(id: number, input: HTMLElement) {
    this.editId = id;
    setTimeout(() => {
      input.focus();
      input.autofocus = true;
    }, 600);
  }
  editGroupName(event: any, group: any) {
    const value = event.target.value;
    if (value === group.Name) {
      this.editId = 0;
      return;
    }
    // this.editId = 0;
    group.Name = value;
    group.Description = value;
    this.subscriptions.push(
      this.attributesService
        .modifyGroupName(this.editId, group)
        .subscribe(() => {
          this.message.success("Group's name modified successfully");
          this.editId = 0;
        })
    );
  }
  deleteGroup(groupId: number) {
    this.attributesService
      .deleteAttributeGroup(groupId)
      .pipe(
        tap(() => {
          this.formGroup
            .get('AttributeGroups')
            ?.setValue(this.AttributeGroups.filter((x) => x.Id !== groupId));
          this.message.success('Attribute Group deleted successfully');
        })
      )
      .subscribe();
  }
}
